import BezierEasing from 'bezier-easing';
import { clamp } from "./math";
export { BezierEasing };
export var Easing = {
  ease: BezierEasing(0.25, 0.1, 0.25, 1),
  linear: BezierEasing(0, 0, 1, 1),
  easeIn: BezierEasing(0.42, 0, 1, 1),
  easeOut: BezierEasing(0, 0, 0.58, 1)
};
export var animation = function animation(distance, duration) {
  var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Easing.ease;
  var start = Date.now();
  return function () {
    var time = duration === 0 ? 1 : clamp(1, 0)((Date.now() - start) / duration);
    return {
      value: distance * easing(time),
      done: time === 1
    };
  };
};
export var returnAnimationValueDelta = function returnAnimationValueDelta(animationFn) {
  var prevValue = 0;
  return function () {
    var _animationFn = animationFn(),
      value = _animationFn.value,
      done = _animationFn.done;
    var delta = value - prevValue;
    prevValue = value;
    return {
      done: done,
      value: delta
    };
  };
};
export var filterAnimationValue = function filterAnimationValue(filterFn, animationFn) {
  return function () {
    var _animationFn2 = animationFn(),
      value = _animationFn2.value,
      done = _animationFn2.done;
    return {
      done: done,
      value: filterFn(value)
    };
  };
};